import { render, staticRenderFns } from "./UpdateStudent.vue?vue&type=template&id=694ca0b3&"
import script from "./UpdateStudent.vue?vue&type=script&lang=js&"
export * from "./UpdateStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports